import { useState } from "react";

const usePagination = () => {
  const [currentPageData, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(0);

  return {
    currentPageData,
    setCurrentPageData,
    currentPage,
    setCurrentPage,
    rowCount,
    setRowCount,
    pageCount,
    setPageCount,
    pageSize,
    setPageSize
  };
};

export default usePagination;
